.bar {
  display: none;
}

@media (min-width: 720px) {
  .bar {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    margin-left: 24px;
  }
}

.links {
  display: flex;
  flex: 1 1 auto;
  gap: 6px;
}

.link {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 0 12px;
  border: 2px solid transparent;
  border-radius: var(--radius-control);
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
}

.link[aria-current='page'] {
  background: var(--accent);
  color: var(--accent-ink);
  border-color: var(--ink);
  box-shadow: 2px 2px 0 var(--ink);
}
